
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import AlertBox from '../../Components/AlertBox';
// const HolidayCreation = () => {
//   const [holidays, setHolidays] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editingHolidayId, setEditingHolidayId] = useState(null);
//   const [companyId, setCompanyId] = useState(null);
//   const [showAlert, setShowAlert] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     startDate: '',
//     endDate: '',
//     reason: '',
//   });
//   const [filters, setFilters] = useState({
//     month: '',
//     year: ''
//   });

//   useEffect(() => {
//     // Get company ID from user token or context
//     const getCompanyId = () => {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         console.error('š No access token found');
//         return null;
//       }

//       try {
//         console.log('DECODING JWT TOKEN FOR COMPANY ID');
//         const decoded = jwtDecode(token);
//         console.log('✅Decoded token:', decoded);

//         // Extract company ID with multiple fallbacks
//         let companyId = decoded.companyId ||
//           decoded.company?._id ||
//           decoded.company ||
//           decoded.orgId ||
//           decoded.organizationId;

//         // If role is 'company', use the id field as company ID
//         if (!companyId && decoded.role === 'company' && decoded.id) {
//           companyId = decoded.id;
//           console.log('✅Using ID as company ID for company role:', companyId);
//         }

//         console.log('✅Extracted company ID:', companyId);

//         if (!companyId) {
//           console.error('❌ No company ID found in token');
//           return null;
//         }

//         return companyId;
//       } catch (error) {
//         console.error('❌ Error decoding JWT token:', error);
//         // Clean up invalid token
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         return null;
//       }
//     };

//     const id = getCompanyId();
//     setCompanyId(id);

//     if (id) {
//       fetchHolidays(id);
//     } else {
//       setError('Company ID not found. Please log in again.');
//       setLoading(false);
//     }
//   }, []);

//   const fetchHolidays = async (companyId) => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setError('No access token found. Please log in.');
//       setLoading(false);
//       return;
//     }

//     try {
//       console.log('🚀 FETCHING HOLIDAYS FOR COMPANY:', companyId);

//       const response = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/company/${companyId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//         validateStatus: (status) => status < 500, // Don't throw for 4xx errors
//       });

//       console.log('¡ HOLIDAYS API RESPONSE:', {
//         status: response.status,
//         statusText: response.statusText,
//         data: response.data
//       });

//       if (response.status === 401) {
//         console.error('š Session expired - cleaning up tokens');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setError('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//         return;
//       }

//       if (response.status === 404) {
//         console.log(' No holidays found for company');
//         setHolidays([]);
//         return;
//       }

//       if (response.status >= 400) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       // Handle different response structures
//       let holidaysData = [];
//       if (Array.isArray(response.data)) {
//         holidaysData = response.data;
//       } else if (response.data.data && Array.isArray(response.data.data)) {
//         holidaysData = response.data.data;
//       } else if (response.data.holidays && Array.isArray(response.data.holidays)) {
//         holidaysData = response.data.holidays;
//       } else if (response.data && typeof response.data === 'object') {
//         holidaysData = [response.data];
//       }

//       console.log('🎯 PROCESSED HOLIDAYS:', holidaysData.length, 'holidays found');
//       setHolidays(holidaysData);

//     } catch (err) {
//       console.error('❌ ERROR FETCHING HOLIDAYS:', {
//         message: err.message,
//         response: err.response?.data,
//         status: err.response?.status
//       });

//       if (err.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setError('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//       } else {
//         setError('Failed to fetch holidays. Please try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const handleAddHoliday = async (e) => {
//     e.preventDefault();

//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setShowAlert('Access token not found. Please login.');
//       return;
//     }

//     if (!companyId) {
//       setShowAlert('Company ID not found. Please login.');
//       return;
//     }

//     const payload = {
//       holidayName: formData.name.trim(),
//       startDate: new Date(formData.startDate).toISOString(),
//       endDate: new Date(formData.endDate).toISOString(),
//       reason: formData.reason.trim(),
//     };

//     try {
//       console.log(' CREATING HOLIDAY:', payload);

//       const response = await axios.post(
//         `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/company/${companyId}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       console.log('✅ HOLIDAY CREATION RESPONSE:', {
//         status: response.status,
//         data: response.data
//       });

//       if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//         return;
//       }

//       if (response.status >= 400) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       setShowAlert('Holiday created successfully!');
//       fetchHolidays(companyId);
//       resetForm();
//     } catch (error) {
//       console.error('❌ ERROR CREATING HOLIDAY:', {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status
//       });

//       if (error.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//       } else {
//         setShowAlert(`Error creating holiday: ${error.response?.data?.message || error.message}`);
//       }
//     }
//   };

//   const handleEditHoliday = (holiday) => {
//     setIsEditing(true);
//     setEditingHolidayId(holiday._id);
//     setFormData({
//       name: holiday.holidayName || '',
//       startDate: holiday.startDate ? new Date(holiday.startDate).toISOString().split('T')[0] : '',
//       endDate: holiday.endDate ? new Date(holiday.endDate).toISOString().split('T')[0] : '',
//       reason: holiday.reason || '',
//     });
//     setShowForm(true);
//   };

//   const handleUpdateHoliday = async (e) => {
//     e.preventDefault();

//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setShowAlert('Access token not found. Please login.');
//       return;
//     }

//     const payload = {
//       holidayName: formData.name.trim(),
//       startDate: new Date(formData.startDate).toISOString(),
//       endDate: new Date(formData.endDate).toISOString(),
//       reason: formData.reason.trim(),
//     };

//     try {
//       console.log(' UPDATING HOLIDAY:', payload);

//       const response = await axios.put(
//         `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/${editingHolidayId}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       console.log('✅ HOLIDAY UPDATE RESPONSE:', {
//         status: response.status,
//         data: response.data
//       });

//       if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//         return;
//       }

//       if (response.status >= 400) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       setShowAlert('Holiday updated successfully!');
//       fetchHolidays(companyId);
//       resetForm();
//     } catch (error) {
//       console.error('❌ ERROR UPDATING HOLIDAY:', {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status
//       });

//       if (error.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//       } else {
//         setShowAlert(`Error updating holiday: ${error.response?.data?.message || error.message}`);
//       }
//     }
//   };

//   const handleDeleteHoliday = async (holidayId) => {
//     if (!window.confirm('Are you sure you want to delete this holiday? This action cannot be undone.')) {
//       return;
//     }

//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setShowAlert('Access token not found. Please login.');
//       return;
//     }

//     try {
//       console.log('—ï DELETING HOLIDAY:', holidayId);

//       const response = await axios.delete(
//         `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/${holidayId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       console.log('✅ HOLIDAY DELETION RESPONSE:', {
//         status: response.status,
//         data: response.data
//       });

//       if (response.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//         return;
//       }

//       if (response.status >= 400) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       setShowAlert('Holiday deleted successfully!');
//       fetchHolidays(companyId); // Refresh the list
//     } catch (error) {
//       console.error('❌ ERROR DELETING HOLIDAY:', {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status
//       });

//       if (error.response?.status === 401) {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userData');
//         localStorage.removeItem('userRole');
//         setShowAlert('Session expired. Please log in again.');
//         setTimeout(() => {
//           window.location.href = '/login';
//         }, 2000);
//       } else {
//         setShowAlert(`Error deleting holiday: ${error.response?.data?.message || error.message}`);
//       }
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       name: '',
//       startDate: '',
//       endDate: '',
//       reason: '',
//     });
//     setShowForm(false);
//     setIsEditing(false);
//     setEditingHolidayId(null);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       return new Date(dateString).toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric',
//         weekday: 'long'
//       });
//     } catch (error) {
//       return 'Invalid Date';
//     }
//   };

//   const isDatePassed = (dateString) => {
//     if (!dateString) return false;
//     const holidayDate = new Date(dateString);
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     return holidayDate < today;
//   };

//   // Filter holidays based on selected month and year
//   const getFilteredHolidays = () => {
//     if (!filters.month && !filters.year) {
//       return holidays;
//     }

//     return holidays.filter(holiday => {
//       // Use startDate if available, otherwise fall back to date field for backward compatibility
//       const holidayDateToCheck = holiday.startDate || holiday.date;
//       const holidayDate = new Date(holidayDateToCheck);
//       const holidayMonth = holidayDate.getMonth() + 1; // getMonth() returns 0-11
//       const holidayYear = holidayDate.getFullYear();

//       const monthMatch = !filters.month || holidayMonth.toString() === filters.month;
//       const yearMatch = !filters.year || holidayYear.toString() === filters.year;

//       return monthMatch && yearMatch;
//     });
//   };

//   const handleFilterChange = (filterType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   const clearFilters = () => {
//     setFilters({
//       month: '',
//       year: ''
//     });
//   };

//   // Get unique years from holidays for year dropdown
//   const getAvailableYears = () => {
//     const years = holidays.map(holiday => {
//       const dateToCheck = holiday.startDate || holiday.date;
//       return new Date(dateToCheck).getFullYear();
//     });
//     const uniqueYears = [...new Set(years)].sort((a, b) => b - a);
//     return uniqueYears;
//   };

//   const filteredHolidays = getFilteredHolidays();

//   // Month options
//   const monthOptions = [
//     { value: '1', label: 'January' },
//     { value: '2', label: 'February' },
//     { value: '3', label: 'March' },
//     { value: '4', label: 'April' },
//     { value: '5', label: 'May' },
//     { value: '6', label: 'June' },
//     { value: '7', label: 'July' },
//     { value: '8', label: 'August' },
//     { value: '9', label: 'September' },
//     { value: '10', label: 'October' },
//     { value: '11', label: 'November' },
//     { value: '12', label: 'December' }
//   ];

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-indigo-100">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading holidays...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-indigo-100">
//         <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
//           <div className="text-red-500 text-center">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <p className="text-lg font-medium">{error}</p>
//             <button
//               onClick={() => window.location.reload()}
//               className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         {/* Header Section */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
//           <div className="mb-6 md:mb-0">
//             <div className="flex items-center mb-3">
//               <div className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl shadow-md mr-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                 </svg>
//               </div>
//               <h1 className="text-4xl font-bold text-slate-800">Holiday Manager</h1>
//             </div>
//             <p className="text-slate-600 ml-16">Manage company holidays and special occasions</p>
//           </div>
//           <button
//             onClick={() => {
//               if (showForm) resetForm();
//               else setShowForm(true);
//             }}
//             className="px-6 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-xl hover:from-blue-600 hover:to-cyan-600 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center shadow-md hover:shadow-lg"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
//             </svg>
//             {showForm ? 'Cancel' : 'Add Holiday'}
//           </button>
//         </div>

//         {/* Filter Section */}
//         <div className="bg-white rounded-2xl shadow-sm p-6 mb-8 border border-slate-100">
//           <div className="flex items-center mb-4">
//             <div className="p-2 bg-purple-100 rounded-lg mr-3">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
//               </svg>
//             </div>
//             <h2 className="text-lg font-semibold text-slate-800">Filter Holidays</h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             {/* Month Filter */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                 </svg>
//                 Filter by Month
//               </label>
//               <select
//                 value={filters.month}
//                 onChange={(e) => handleFilterChange('month', e.target.value)}
//                 className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-colors shadow-sm bg-white"
//               >
//                 <option value="">All Months</option>
//                 {monthOptions.map(month => (
//                   <option key={month.value} value={month.value}>{month.label}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Year Filter */}
//             <div>
//               <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 Filter by Year
//               </label>
//               <select
//                 value={filters.year}
//                 onChange={(e) => handleFilterChange('year', e.target.value)}
//                 className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-colors shadow-sm bg-white"
//               >
//                 <option value="">All Years</option>
//                 {getAvailableYears().map(year => (
//                   <option key={year} value={year}>{year}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Clear Filters Button */}
//             <div className="flex items-end">
//               <button
//                 onClick={clearFilters}
//                 disabled={!filters.month && !filters.year}
//                 className="w-full px-4 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-lg hover:from-purple-600 hover:to-pink-600 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//                 Clear Filters
//               </button>
//             </div>
//           </div>

//           {/* Filter Status */}
//           {(filters.month || filters.year) && (
//             <div className="mt-4 p-3 bg-purple-50 rounded-lg border border-purple-200">
//               <div className="flex items-center text-sm text-purple-700">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 <span>
//                   Showing holidays for {filters.month && monthOptions.find(m => m.value === filters.month)?.label}
//                   {filters.month && filters.year && ' '}
//                   {filters.year && filters.year}
//                   {!filters.month && filters.year && 'year ' + filters.year}
//                   {filters.month && !filters.year && ' (all years)'}
//                 </span>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Stats Overview with Gradient Colors */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
//           {/* Total Holidays Box */}
//           <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-5 rounded-2xl shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//             <div className="flex justify-between items-start">
//               <div>
//                 <h3 className="text-3xl font-bold">{filteredHolidays.length}</h3>
//                 <p className="text-blue-100 text-sm mt-1">{(filters.month || filters.year) ? 'Filtered' : 'Total'} Holidays</p>
//               </div>
//               <div className="p-2 bg-white bg-opacity-20 rounded-xl">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                 </svg>
//               </div>
//             </div>
//             <div className="flex items-center mt-4 text-blue-100 text-sm">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//               All recorded holidays
//             </div>
//           </div>

//           {/* Upcoming Holidays Box */}
//           <div className="bg-gradient-to-r from-emerald-500 to-teal-500 p-5 rounded-2xl shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//             <div className="flex justify-between items-start">
//               <div>
//                 <h3 className="text-3xl font-bold">{filteredHolidays.filter(h => !isDatePassed(h.date)).length}</h3>
//                 <p className="text-emerald-100 text-sm mt-1">Upcoming Holidays</p>
//               </div>
//               <div className="p-2 bg-white bg-opacity-20 rounded-xl">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//             </div>
//             <div className="flex items-center mt-4 text-emerald-100 text-sm">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//               </svg>
//               Future events to look forward to
//             </div>
//           </div>

//           {/* Past Holidays Box */}
//           <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-5 rounded-2xl shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//             <div className="flex justify-between items-start">
//               <div>
//                 <h3 className="text-3xl font-bold">{filteredHolidays.filter(h => isDatePassed(h.date)).length}</h3>
//                 <p className="text-purple-100 text-sm mt-1">Past Holidays</p>
//               </div>
//               <div className="p-2 bg-white bg-opacity-20 rounded-xl">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//             </div>
//             <div className="flex items-center mt-4 text-purple-100 text-sm">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//               Celebrated and remembered
//             </div>
//           </div>
//         </div>

//         {/* Rest of the component remains the same */}
//         {showForm && (
//           <div className="bg-white rounded-2xl shadow-md p-6 mb-10 border border-slate-100 animate-slide-down">
//             <div className="flex items-center mb-6">
//               <div className="p-2 bg-blue-100 rounded-lg mr-3">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                 </svg>
//               </div>
//               <h2 className="text-xl font-semibold text-slate-800">
//                 {isEditing ? 'Edit Holiday' : 'Add New Holiday'}
//               </h2>
//             </div>
//             <form onSubmit={isEditing ? handleUpdateHoliday : handleAddHoliday} className="space-y-6">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="md:col-span-2">
//                   <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
//                     </svg>
//                     Holiday Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
//                     placeholder="Enter holiday name (e.g., Christmas, New Year)"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                     </svg>
//                     Start Date *
//                   </label>
//                   <input
//                     type="date"
//                     name="startDate"
//                     value={formData.startDate}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                     </svg>
//                     End Date *
//                   </label>
//                   <input
//                     type="date"
//                     name="endDate"
//                     value={formData.endDate}
//                     onChange={handleInputChange}
//                     required
//                     min={formData.startDate}
//                     className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
//                   />
//                 </div>

//                 <div className="md:col-span-2">
//                   <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                     </svg>
//                     Reason/Description *
//                   </label>
//                   <textarea
//                     name="reason"
//                     value={formData.reason}
//                     onChange={handleInputChange}
//                     required
//                     rows="4"
//                     className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm resize-none"
//                     placeholder="Enter the reason for this holiday (e.g., National festival, Company annual closure, etc.)"
//                   />
//                 </div>
//               </div>

//               <div className="pt-4 flex justify-center gap-3">
//                 <button
//                   type="submit"
//                   className="px-8 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-cyan-600 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg"
//                 >
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                   </svg>
//                   {isEditing ? 'Update Holiday' : 'Add Holiday'}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={resetForm}
//                   className="px-8 py-3 bg-slate-100 text-slate-700 font-semibold rounded-lg hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2 transition-all duration-300"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         )}

//         {/* Holiday List Section */}
//         <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100">
//           <div className="px-6 py-4 border-b border-slate-200 bg-slate-50">
//             <div className="flex items-center">
//               <div className="p-2 bg-blue-100 rounded-lg mr-3">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                 </svg>
//               </div>
//               <h2 className="text-xl font-semibold text-slate-800">
//                 Holiday List
//               </h2>
//             </div>
//             <p className="text-slate-600 text-sm ml-10">{filteredHolidays.length} holidays found{(filters.month || filters.year) ? ' (filtered)' : ''}</p>
//           </div>

//           {filteredHolidays.length === 0 ? (
//             <div className="p-12 text-center">
//               <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
//                 </svg>
//               </div>
//               <p className="mt-4 text-slate-600">
//                 {holidays.length === 0
//                   ? 'No holidays found. Add your first holiday to get started.'
//                   : 'No holidays match the selected filters. Try adjusting your filter criteria.'
//                 }
//               </p>
//               {holidays.length === 0 ? (
//                 <button
//                   onClick={() => setShowForm(true)}
//                   className="mt-4 px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-cyan-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
//                 >
//                   Add First Holiday
//                 </button>
//               ) : (
//                 <button
//                   onClick={clearFilters}
//                   className="mt-4 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
//                 >
//                   Clear Filters
//                 </button>
//               )}
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-slate-200">
//                 <thead className="bg-slate-50">
//                   <tr>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       #
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Holiday
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Start Date
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       End Date
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Duration
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Reason
//                     </th>

//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-slate-200">
//                   {filteredHolidays.map((holiday, index) => {
//                     const startDate = holiday.startDate || holiday.date;
//                     const endDate = holiday.endDate || holiday.date;
//                     const daysDiff = Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)) + 1;

//                     return (
//                       <tr key={holiday._id} className="hover:bg-slate-50 transition-colors duration-150">
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
//                           <div className="w-8 h-8 flex items-center justify-center bg-slate-100 rounded-lg">
//                             {index + 1}
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="text-sm font-medium text-slate-900">{holiday.holidayName}</div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
//                           <div className="flex flex-col">
//                             <span className="font-medium">{formatDate(startDate)}</span>
//                             <span className="text-xs text-slate-500">{new Date(startDate).toLocaleDateString('en-GB')}</span>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
//                           <div className="flex flex-col">
//                             <span className="font-medium">{formatDate(endDate)}</span>
//                             <span className="text-xs text-slate-500">{new Date(endDate).toLocaleDateString('en-GB')}</span>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
//                           <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                             {daysDiff} {daysDiff === 1 ? 'day' : 'days'}
//                           </span>
//                         </td>
//                         <td className="px-6 py-4 text-sm text-slate-600 max-w-xs">
//                           <div className="truncate" title={holiday.reason || 'N/A'}>
//                             {holiday.reason || 'N/A'}
//                           </div>
//                         </td>

//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                           <div className="flex space-x-3">
//                             <button
//                               onClick={() => handleEditHoliday(holiday)}
//                               className="text-blue-600 hover:text-blue-800 transition-colors duration-200 flex items-center"
//                             >
//                               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                               </svg>
//                               Edit
//                             </button>
//                             <button
//                               onClick={() => handleDeleteHoliday(holiday._id)}
//                               className="text-rose-600 hover:text-rose-800 transition-colors duration-200 flex items-center"
//                             >
//                               <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                               </svg>
//                               Delete
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes slideDown {
//           from { transform: translateY(-10px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }
//         .animate-slide-down {
//           animation: slideDown 0.3s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default HolidayCreation;





import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import AlertBox from '../../Components/AlertBox';

const ResponsiveSelect = ({ value, onChange, options, placeholder, name, required, disabled, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = React.useRef(null);
  const dropdownRef = React.useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target) &&
        (!dropdownRef.current || !dropdownRef.current.contains(event.target))) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const openDropdown = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  const selectedOpt = options.find(o => String(o.value) === String(value));
  const displayLabel = selectedOpt ? selectedOpt.label : placeholder;

  const dropdownMenu = isOpen && !disabled ? (
    <div
      ref={dropdownRef}
      className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-xl max-h-60 overflow-y-auto"
      style={{
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      }}
    >
      {placeholder && (
        <div
          onClick={() => {
            onChange({ target: { name, value: '' } });
            setIsOpen(false);
          }}
          className={`p-3 border-b border-slate-50 text-sm cursor-pointer ${!value ? 'bg-purple-50 text-purple-700 font-semibold' : 'bg-transparent text-slate-700 font-normal'}`}
        >
          {placeholder}
        </div>
      )}
      {options.map(opt => (
        <div
          key={opt.value}
          onClick={() => {
            onChange({ target: { name, value: opt.value } });
            setIsOpen(false);
          }}
          className={`p-3 border-b border-slate-50 text-sm cursor-pointer break-words ${String(value) === String(opt.value) ? 'bg-purple-50 text-purple-700 font-semibold' : 'bg-transparent text-slate-700 font-normal'}`}
        >
          {opt.label}
        </div>
      ))}
    </div>
  ) : null;

  return (
    <div className="w-full relative" ref={wrapperRef}>
      {/* Desktop Native Select */}
      <select
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`hidden md:block w-full ${className}`}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>

      {/* Mobile Custom Select */}
      <div className="md:hidden">
        <div
          onClick={openDropdown}
          className={`w-full flex justify-between items-center bg-white shadow-sm transition-colors ${className} ${disabled ? 'opacity-70 cursor-not-allowed bg-slate-50' : 'cursor-pointer'}`}
        >
          <div className="text-left overflow-hidden text-ellipsis whitespace-nowrap flex-1">
            {displayLabel}
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2 text-slate-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        {dropdownMenu}
      </div>
    </div>
  );
};

const HolidayCreation = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingHolidayId, setEditingHolidayId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    reason: '',
  });
  const [filters, setFilters] = useState({
    month: '',
    year: ''
  });

  useEffect(() => {
    // Get company ID from user token or context
    const getCompanyId = () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('š No access token found');
        return null;
      }

      try {
        console.log('DECODING JWT TOKEN FOR COMPANY ID');
        const decoded = jwtDecode(token);
        console.log('✅Decoded token:', decoded);

        // Extract company ID with multiple fallbacks
        let companyId = decoded.companyId ||
          decoded.company?._id ||
          decoded.company ||
          decoded.orgId ||
          decoded.organizationId;

        // If role is 'company', use the id field as company ID
        if (!companyId && decoded.role === 'company' && decoded.id) {
          companyId = decoded.id;
          console.log('✅Using ID as company ID for company role:', companyId);
        }

        console.log('✅Extracted company ID:', companyId);

        if (!companyId) {
          console.error('❌ No company ID found in token');
          return null;
        }

        return companyId;
      } catch (error) {
        console.error('❌ Error decoding JWT token:', error);
        // Clean up invalid token
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        return null;
      }
    };

    const id = getCompanyId();
    setCompanyId(id);

    if (id) {
      fetchHolidays(id);
    } else {
      setError('Company ID not found. Please log in again.');
      setLoading(false);
    }
  }, []);

  const fetchHolidays = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('No access token found. Please log in.');
      setLoading(false);
      return;
    }

    try {
      console.log('🚀 FETCHING HOLIDAYS FOR COMPANY:', companyId);

      const response = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: (status) => status < 500, // Don't throw for 4xx errors
      });

      console.log('¡ HOLIDAYS API RESPONSE:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data
      });

      if (response.status === 401) {
        console.error('š Session expired - cleaning up tokens');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setError('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      if (response.status === 404) {
        console.log(' No holidays found for company');
        setHolidays([]);
        return;
      }

      if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      // Handle different response structures
      let holidaysData = [];
      if (Array.isArray(response.data)) {
        holidaysData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        holidaysData = response.data.data;
      } else if (response.data.holidays && Array.isArray(response.data.holidays)) {
        holidaysData = response.data.holidays;
      } else if (response.data && typeof response.data === 'object') {
        holidaysData = [response.data];
      }

      console.log('🎯 PROCESSED HOLIDAYS:', holidaysData.length, 'holidays found');
      setHolidays(holidaysData);

    } catch (err) {
      console.error('❌ ERROR FETCHING HOLIDAYS:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });

      if (err.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setError('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setError('Failed to fetch holidays. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleAddHoliday = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('authToken');
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    if (!companyId) {
      setShowAlert('Company ID not found. Please login.');
      return;
    }

    const payload = {
      holidayName: formData.name.trim(),
      startDate: new Date(formData.startDate).toISOString(),
      endDate: new Date(formData.endDate).toISOString(),
      reason: formData.reason.trim(),
    };

    try {
      console.log(' CREATING HOLIDAY:', payload);

      const response = await axios.post(
        `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/company/${companyId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          validateStatus: (status) => status < 500,
        }
      );

      console.log('✅ HOLIDAY CREATION RESPONSE:', {
        status: response.status,
        data: response.data
      });

      if (response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      setShowAlert('Holiday created successfully!');
      fetchHolidays(companyId);
      resetForm();
    } catch (error) {
      console.error('❌ ERROR CREATING HOLIDAY:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });

      if (error.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setShowAlert(`Error creating holiday: ${error.response?.data?.message || error.message}`);
      }
    }
  };

  const handleEditHoliday = (holiday) => {
    setIsEditing(true);
    setEditingHolidayId(holiday._id);
    setFormData({
      name: holiday.holidayName || '',
      startDate: holiday.startDate ? new Date(holiday.startDate).toISOString().split('T')[0] : '',
      endDate: holiday.endDate ? new Date(holiday.endDate).toISOString().split('T')[0] : '',
      reason: holiday.reason || '',
    });
    setShowForm(true);
  };

  const handleUpdateHoliday = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('authToken');
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    const payload = {
      holidayName: formData.name.trim(),
      startDate: new Date(formData.startDate).toISOString(),
      endDate: new Date(formData.endDate).toISOString(),
      reason: formData.reason.trim(),
    };

    try {
      console.log(' UPDATING HOLIDAY:', payload);

      const response = await axios.put(
        `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/${editingHolidayId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          validateStatus: (status) => status < 500,
        }
      );

      console.log('✅ HOLIDAY UPDATE RESPONSE:', {
        status: response.status,
        data: response.data
      });

      if (response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      setShowAlert('Holiday updated successfully!');
      fetchHolidays(companyId);
      resetForm();
    } catch (error) {
      console.error('❌ ERROR UPDATING HOLIDAY:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });

      if (error.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setShowAlert(`Error updating holiday: ${error.response?.data?.message || error.message}`);
      }
    }
  };

  const handleDeleteHoliday = async (holidayId) => {
    if (!window.confirm('Are you sure you want to delete this holiday? This action cannot be undone.')) {
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    try {
      console.log('—ï DELETING HOLIDAY:', holidayId);

      const response = await axios.delete(
        `https://slateblue-mallard-430836.hostingersite.com/api/holidaycreation/${holidayId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          validateStatus: (status) => status < 500,
        }
      );

      console.log('✅ HOLIDAY DELETION RESPONSE:', {
        status: response.status,
        data: response.data
      });

      if (response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      setShowAlert('Holiday deleted successfully!');
      fetchHolidays(companyId); // Refresh the list
    } catch (error) {
      console.error('❌ ERROR DELETING HOLIDAY:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });

      if (error.response?.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userRole');
        setShowAlert('Session expired. Please log in again.');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setShowAlert(`Error deleting holiday: ${error.response?.data?.message || error.message}`);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      startDate: '',
      endDate: '',
      reason: '',
    });
    setShowForm(false);
    setIsEditing(false);
    setEditingHolidayId(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const isDatePassed = (dateString) => {
    if (!dateString) return false;
    const holidayDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return holidayDate < today;
  };

  // Filter holidays based on selected month and year
  const getFilteredHolidays = () => {
    if (!filters.month && !filters.year) {
      return holidays;
    }

    return holidays.filter(holiday => {
      // Use startDate if available, otherwise fall back to date field for backward compatibility
      const holidayDateToCheck = holiday.startDate || holiday.date;
      const holidayDate = new Date(holidayDateToCheck);
      const holidayMonth = holidayDate.getMonth() + 1; // getMonth() returns 0-11
      const holidayYear = holidayDate.getFullYear();

      const monthMatch = !filters.month || holidayMonth.toString() === filters.month;
      const yearMatch = !filters.year || holidayYear.toString() === filters.year;

      return monthMatch && yearMatch;
    });
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setFilters({
      month: '',
      year: ''
    });
  };

  // Get unique years from holidays for year dropdown
  const getAvailableYears = () => {
    const years = holidays.map(holiday => {
      const dateToCheck = holiday.startDate || holiday.date;
      return new Date(dateToCheck).getFullYear();
    });
    const uniqueYears = [...new Set(years)].sort((a, b) => b - a);
    return uniqueYears;
  };

  const filteredHolidays = getFilteredHolidays();

  // Month options
  const monthOptions = [
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' }
  ];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading holidays...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-indigo-100">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-500 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-lg font-medium">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-2 md:p-4">
      <div className="max-w-full mx-auto">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 md:mb-10">
          <div className="mb-6 md:mb-0">
            <div className="flex items-center mb-2 md:mb-3">
              <div className="p-2 md:p-3 bg-gradient-to-r from-[#1cb0f6] to-[#1cb0f6] md:from-blue-500 md:to-cyan-500 rounded-xl shadow-md mr-3 md:mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 md:h-8 md:w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                </svg>
              </div>
              <h1 className="text-xl md:text-4xl font-bold text-slate-800">Holiday Manager</h1>
            </div>
            <p className="text-xs md:text-base text-slate-600 ml-12 md:ml-16">Manage company holidays and special occasions</p>
          </div>
          <button
            onClick={() => {
              if (showForm) resetForm();
              else setShowForm(true);
            }}
            className="w-full md:w-auto px-6 py-3 bg-gradient-to-r from-[#1cb0f6] to-[#1cb0f6] md:from-blue-500 md:to-cyan-500 text-white font-semibold rounded-xl hover:opacity-90 md:hover:from-blue-600 md:hover:to-cyan-600 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
            </svg>
            {showForm ? 'Cancel' : 'Add Holiday'}
          </button>
        </div>

        {/* Filter Section */}
        <div className="bg-white rounded-2xl shadow-sm p-4 md:p-6 mb-6 md:mb-8 border border-slate-100">
          <div className="flex items-center mb-4">
            <div className="p-2 bg-purple-100 rounded-lg mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
            </div>
            <h2 className="text-base md:text-lg font-semibold text-slate-800">Filter Holidays</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Month Filter */}
            <div>
              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1.5 md:mb-2 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 md:h-4 md:w-4 mr-1 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                </svg>
                Filter by Month
              </label>
              <ResponsiveSelect
                name="month"
                value={filters.month}
                onChange={(e) => handleFilterChange('month', e.target.value)}
                options={monthOptions}
                placeholder="All Months"
                className="px-3 py-2.5 md:px-4 md:py-3 text-sm md:text-base border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
              />
            </div>

            {/* Year Filter */}
            <div>
              <label className="block text-xs md:text-sm font-medium text-slate-700 mb-1.5 md:mb-2 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 md:h-4 md:w-4 mr-1 text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Filter by Year
              </label>
              <ResponsiveSelect
                name="year"
                value={filters.year}
                onChange={(e) => handleFilterChange('year', e.target.value)}
                options={getAvailableYears().map(year => ({ value: year, label: year }))}
                placeholder="All Years"
                className="px-3 py-2.5 md:px-4 md:py-3 text-sm md:text-base border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
              />
            </div>

            {/* Clear Filters Button */}
            <div className="flex items-end mt-2 md:mt-0">
              <button
                onClick={clearFilters}
                disabled={!filters.month && !filters.year}
                className="w-full px-4 py-2.5 md:py-3 bg-gradient-to-r from-[#f0a8d0] to-[#f0a8d0] md:from-purple-500 md:to-pink-500 text-white font-semibold rounded-lg hover:opacity-90 md:hover:from-purple-600 md:hover:to-pink-600 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Clear Filters
              </button>
            </div>
          </div>

          {/* Filter Status */}
          {(filters.month || filters.year) && (
            <div className="mt-4 p-3 bg-purple-50 rounded-lg border border-purple-200">
              <div className="flex items-center text-sm text-purple-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>
                  Showing holidays for {filters.month && monthOptions.find(m => m.value === filters.month)?.label}
                  {filters.month && filters.year && ' '}
                  {filters.year && filters.year}
                  {!filters.month && filters.year && 'year ' + filters.year}
                  {filters.month && !filters.year && ' (all years)'}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Stats Overview with Gradient Colors */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-10">
          {/* Total Holidays Box */}
          <div className="bg-gradient-to-r from-[#1cb0f6] to-[#1cb0f6] md:from-blue-500 md:to-cyan-500 p-4 md:p-5 rounded-2xl shadow-md md:shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">{filteredHolidays.length}</h3>
                <p className="text-blue-50 md:text-blue-100 text-xs md:text-sm mt-1">{(filters.month || filters.year) ? 'Filtered' : 'Total'} Holidays</p>
              </div>
              <div className="p-1.5 md:p-2 bg-white bg-opacity-20 rounded-xl">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                </svg>
              </div>
            </div>
            <div className="flex items-center mt-3 md:mt-4 text-blue-50 md:text-blue-100 text-xs md:text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 md:h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              All recorded holidays
            </div>
          </div>

          {/* Upcoming Holidays Box */}
          <div className="bg-gradient-to-r from-[#20c997] to-[#20c997] md:from-emerald-500 md:to-teal-500 p-4 md:p-5 rounded-2xl shadow-md md:shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">{filteredHolidays.filter(h => !isDatePassed(h.date)).length}</h3>
                <p className="text-emerald-50 md:text-emerald-100 text-xs md:text-sm mt-1">Upcoming Holidays</p>
              </div>
              <div className="p-1.5 md:p-2 bg-white bg-opacity-20 rounded-xl">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="flex items-center mt-3 md:mt-4 text-emerald-50 md:text-emerald-100 text-xs md:text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 md:h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Future events to look forward to
            </div>
          </div>

          {/* Past Holidays Box */}
          <div className="bg-gradient-to-r from-[#a855f7] to-[#a855f7] md:from-purple-500 md:to-pink-500 p-4 md:p-5 rounded-2xl shadow-md md:shadow-lg text-white transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">{filteredHolidays.filter(h => isDatePassed(h.date)).length}</h3>
                <p className="text-purple-50 md:text-purple-100 text-xs md:text-sm mt-1">Past Holidays</p>
              </div>
              <div className="p-1.5 md:p-2 bg-white bg-opacity-20 rounded-xl">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="flex items-center mt-3 md:mt-4 text-purple-50 md:text-purple-100 text-xs md:text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 md:h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Celebrated and remembered
            </div>
          </div>
        </div>

        {/* Rest of the component remains the same */}
        {showForm && (
          <div className="bg-white rounded-2xl shadow-md p-6 mb-10 border border-slate-100 animate-slide-down">
            <div className="flex items-center mb-6">
              <div className="p-2 bg-blue-100 rounded-lg mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-slate-800">
                {isEditing ? 'Edit Holiday' : 'Add New Holiday'}
              </h2>
            </div>
            <form onSubmit={isEditing ? handleUpdateHoliday : handleAddHoliday} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                    </svg>
                    Holiday Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
                    placeholder="Enter holiday name (e.g., Christmas, New Year)"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                    </svg>
                    Start Date *
                  </label>
                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                    </svg>
                    End Date *
                  </label>
                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleInputChange}
                    required
                    min={formData.startDate}
                    className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-2 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Reason/Description *
                  </label>
                  <textarea
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                    required
                    rows="4"
                    className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors shadow-sm resize-none"
                    placeholder="Enter the reason for this holiday (e.g., National festival, Company annual closure, etc.)"
                  />
                </div>
              </div>

              <div className="pt-4 flex justify-center gap-3">
                <button
                  type="submit"
                  className="px-8 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-cyan-600 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {isEditing ? 'Update Holiday' : 'Add Holiday'}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  className="px-8 py-3 bg-slate-100 text-slate-700 font-semibold rounded-lg hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2 transition-all duration-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Holiday List Section */}
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100">
          <div className="px-6 py-4 border-b border-slate-200 bg-slate-50">
            <div className="flex items-center">
              <div className="p-2 bg-blue-100 rounded-lg mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-slate-800">
                Holiday List
              </h2>
            </div>
            <p className="text-slate-600 text-sm ml-10">{filteredHolidays.length} holidays found{(filters.month || filters.year) ? ' (filtered)' : ''}</p>
          </div>

          {filteredHolidays.length === 0 ? (
            <div className="p-12 text-center">
              <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                </svg>
              </div>
              <p className="mt-4 text-slate-600">
                {holidays.length === 0
                  ? 'No holidays found. Add your first holiday to get started.'
                  : 'No holidays match the selected filters. Try adjusting your filter criteria.'
                }
              </p>
              {holidays.length === 0 ? (
                <button
                  onClick={() => setShowForm(true)}
                  className="mt-4 px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-cyan-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
                >
                  Add First Holiday
                </button>
              ) : (
                <button
                  onClick={clearFilters}
                  className="mt-4 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
                >
                  Clear Filters
                </button>
              )}
            </div>
          ) : (
            <>
              {/* Desktop View (Table) */}
              <div className="hidden md:block overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                  <thead className="bg-slate-50">
                    <tr>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Sr.No
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Holiday
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Start Date
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        End Date
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Duration
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Reason
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200">
                    {filteredHolidays.map((holiday, index) => {
                      const startDate = holiday.startDate || holiday.date;
                      const endDate = holiday.endDate || holiday.date;
                      const daysDiff = Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)) + 1;

                      return (
                        <tr key={holiday._id} className="hover:bg-slate-50 transition-colors duration-150">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                            <div className="w-8 h-8 flex items-center justify-center bg-slate-100 rounded-lg">
                              {index + 1}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-slate-900">{holiday.holidayName}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                            <div className="flex flex-col">
                              <span className="font-medium">{formatDate(startDate)}</span>
                              <span className="text-xs text-slate-500">{new Date(startDate).toLocaleDateString('en-GB')}</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                            <div className="flex flex-col">
                              <span className="font-medium">{formatDate(endDate)}</span>
                              <span className="text-xs text-slate-500">{new Date(endDate).toLocaleDateString('en-GB')}</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              {daysDiff} {daysDiff === 1 ? 'day' : 'days'}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-sm text-slate-600 max-w-xs">
                            <div className="truncate" title={holiday.reason || 'N/A'}>
                              {holiday.reason || 'N/A'}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <div className="flex space-x-3">
                              <button
                                onClick={() => handleEditHoliday(holiday)}
                                className="text-blue-600 hover:text-blue-800 transition-colors duration-200 flex items-center"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                Edit
                              </button>
                              <button
                                onClick={() => handleDeleteHoliday(holiday._id)}
                                className="text-rose-600 hover:text-rose-800 transition-colors duration-200 flex items-center"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile View (Cards) */}
              <div className="md:hidden flex flex-col space-y-4 p-4">
                {filteredHolidays.map((holiday, index) => {
                  const startDate = holiday.startDate || holiday.date;
                  const endDate = holiday.endDate || holiday.date;
                  const daysDiff = Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)) + 1;

                  return (
                    <div key={holiday._id} className="relative bg-white rounded-xl shadow-md border border-slate-100 overflow-hidden transition-all duration-200 hover:shadow-lg">
                      <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-[#1cb0f6] to-[#0077b6]"></div>
                      <div className="p-4 pl-5">
                        <div className="flex justify-between items-start mb-3">
                          <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-gradient-to-r from-blue-100 to-cyan-100 rounded-lg flex items-center justify-center shadow-sm flex-shrink-0">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h3z" />
                              </svg>
                            </div>
                            <div>
                              <h3 className="text-base font-semibold text-slate-800 break-words">{holiday.holidayName}</h3>
                              <p className="text-xs text-slate-500">Sr.No: {index + 1}</p>
                            </div>
                          </div>
                          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100">
                            {daysDiff} {daysDiff === 1 ? 'day' : 'days'}
                          </span>
                        </div>

                        <div className="bg-slate-50 rounded-lg p-3 mb-3 border border-slate-100">
                          <div className="grid grid-cols-2 gap-2 text-xs">
                            <div>
                              <p className="text-slate-500 mb-1">Start Date</p>
                              <p className="font-medium text-slate-800">{new Date(startDate).toLocaleDateString('en-GB')}</p>
                            </div>
                            <div>
                              <p className="text-slate-500 mb-1">End Date</p>
                              <p className="font-medium text-slate-800">{new Date(endDate).toLocaleDateString('en-GB')}</p>
                            </div>
                            <div className="col-span-2 mt-1">
                              <p className="text-slate-500 mb-1">Reason</p>
                              <p className="font-medium text-slate-800 break-words">{holiday.reason || 'N/A'}</p>
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-end space-x-2 pt-1">
                          <button
                            onClick={() => handleEditHoliday(holiday)}
                            className="flex-1 flex justify-center items-center px-3 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors"
                          >
                            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteHoliday(holiday._id)}
                            className="flex-1 flex justify-center items-center px-3 py-2 bg-rose-50 text-rose-600 rounded-lg text-sm font-medium hover:bg-rose-100 transition-colors"
                          >
                            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes slideDown {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-down {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default HolidayCreation;


